import { render, staticRenderFns } from "./IconShop.vue?vue&type=template&id=a046cbd8&"
import script from "./IconShop.vue?vue&type=script&lang=ts&"
export * from "./IconShop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports